import {List, Map} from 'immutable'
import PropTypes from 'prop-types'

import Button from '../../../../../shared_components/mui_base_components/button/Button'
import Logger from '../../../../../lib/NewLogger'

import {
  DEFAULT_LIFE_STORY_TITLE,
  lifeStoryContinuePath,
  lifeStoryStoryPath,
  storySummary,
  storySummaryForViewer
} from './lifeStoryTools'

import {enterLifeStoryFlow} from './lifeStoryFlowEntry'
import {trackLifeStoryEvent} from './lifeStoryEventLogger'
import routerUtils from '../../../../../lib/routerUtils'

import './lifeStoryItemHeader.scss'

const LifeStoryItemHeader = ({ethicalWill, viewerIsOwner = true, ownerFirstName, everplanId = null, userConfig}) => {
  const title = ethicalWill.getIn(['data', 'title']) || DEFAULT_LIFE_STORY_TITLE
  const stories = (ethicalWill.getIn(['data', 'stories']) || List()).toJS()

  const summary = viewerIsOwner ? storySummary(stories) : storySummaryForViewer({stories, ownerFirstName})

  const enterStory = () => {
    Logger.log({
      name: 'entered_life_story',
      payload: {context: 'item_modal', type: 'vault', wildcard: viewerIsOwner ? 'owner' : 'deputy'}
    })
    trackLifeStoryEvent({eventName: 'view_my_story', userConfig, viewerIsOwner})
    routerUtils.push(lifeStoryStoryPath({ethicalWillId: ethicalWill.get('id'), everplanId}))
  }

  const continueStory = () => {
    Logger.log({name: 'clicked_continue_life_story', payload: {context: 'item_modal', type: 'vault'}})
    trackLifeStoryEvent({eventName: 'click_my_story_item_entry', userConfig, payload: {context: 'item_modal'}})
    enterLifeStoryFlow(lifeStoryContinuePath(ethicalWill.get('id')), {openPicker: true})
  }

  return (
    <div className='life-story-item-header'>
      <h4 className='life-story-item-header__title'>{title}</h4>
      <p className='life-story-item-header__summary'>{summary}</p>
      {
        viewerIsOwner ?
          <Button onClick={continueStory}>Continue my story</Button> :
          <Button onClick={enterStory}>Enter the story</Button>
      }
    </div>
  )
}

LifeStoryItemHeader.propTypes = {
  ethicalWill: PropTypes.instanceOf(Map),
  everplanId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ownerFirstName: PropTypes.string,
  userConfig: PropTypes.instanceOf(Map),
  viewerIsOwner: PropTypes.bool
}

export default LifeStoryItemHeader
